module.exports = __webpack_public_path__ + "images/share_black-11c89bad.svg";